import {
  getDownloadingProductImagesOrderNumber,
  getIsDownloadingProductImages,
  getIsDownloadingProductImagesFailed,
} from '@app/ducks/documents';
import { isDefined } from '@app/utils/is';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { WarningOutline } from '../Icons';
import { Spinner } from '../Spinner';
import { addToast, dismissToast } from '../Toasts';

const NOTIFICATION_KEY = 'downloadProductImages';

export const ProductImageMessage = () => {
  const { t } = useTranslation(['common', 'products', 'orders']);
  const isDownloading = useSelector(getIsDownloadingProductImages);
  const hasFailed = useSelector(getIsDownloadingProductImagesFailed);
  const orderNumber = useSelector(getDownloadingProductImagesOrderNumber);

  const notificationContent = React.useMemo(() => {
    const orderNumberText = isDefined(orderNumber) ? t('orders:for_order', { orderNumber }) : '';

    if (isDownloading && !hasFailed) {
      return {
        description: t('products:download_images_hint', { orderNumberText }),
        icon: Spinner,
        message: t('products:preparing_file'),
      };
    }

    return {
      description: t('products:download_images_fail_hint', { orderNumberText }),
      icon: WarningOutline,
      message: t('products:download_images_fail'),
    };
  }, [t, isDownloading, hasFailed, orderNumber]);

  React.useEffect(() => {
    if (!isDownloading && !hasFailed) {
      dismissToast(NOTIFICATION_KEY);

      return;
    }

    const { message, description, icon } = notificationContent;

    addToast(message, {
      description,
      duration: 0,
      icon,
      id: NOTIFICATION_KEY,
    });
  }, [isDownloading, hasFailed, orderNumber, notificationContent]);

  return null;
};
